import * as React from 'react';
import { ReactElement } from 'react';

import ExportExcel from '@/modules/packhouse/printingOrders/components/SupervisorsListing/SupervisorOrderRow/OrdersList/OrderCardContent/Printing/ExportExcel';
import Exportpdf from '@/modules/packhouse/printingOrders/components/SupervisorsListing/SupervisorOrderRow/OrdersList/OrderCardContent/Printing/Exportpdf';
import { generatePatchBarcodesData } from '@/modules/packhouse/printingOrders/components/SupervisorsListing/SupervisorOrderRow/OrdersList/OrderCardContent/Printing/logic';
import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import { useStore } from '@/shared/hooks/context/createGenericContext';

export interface IPrintingProps {
  order: IPrintingOrders.IOrderItem;
  orderDetails?: IPrintingOrders.IOrderDetailsItem;
  supervisor?: IPrintingOrders.IUser;
}

export default function Printing({
  order,
  orderDetails,
  supervisor,
}: IPrintingProps): ReactElement {
  const [selectedAsset] = useStore((state) => state.asset);

  const patchBarcodesData: IPrintingOrders.IGeneratedWorkerBarcodesDataItem[] =
    React.useMemo(
      () =>
        generatePatchBarcodesData({
          order,
          orderDetails,
          supervisor,
          entityId: selectedAsset?.id,
        }) || [],
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        // order.createdAt,
        // order.start,
        // orderDetails?.numOfTickets,
        // orderDetails?.workers,
        // selectedAsset?.id,
        // supervisor?.userId,
        // supervisor?.userName,
      ]
    );

  return (
    <div className='inline-flex'>
      <Exportpdf patchBarcodesData={patchBarcodesData} />
      <ExportExcel patchBarcodesData={patchBarcodesData} />
    </div>
  );
}
